// import {ProjectSession} from "../project-model-session";
import {ProjectAccess} from "../../../gd/const/project";
import ProjectSession from "../project-session";

// const debug = "canCreateTask"
const debug = false

export default function canCreateTask(project: ProjectSession):boolean {


    // cant add task to archived projects
    // if (gd.const.systemStatus.isClosed(project.systemStatus)) return false
    if (project.isClosed) {
        debug && console.log(debug, "project closed")
        return false
    }

    // no tasks in tags
    if (project.isTag) {
        return false
    }

    // in templates we do not have users
    if (project.isTemplate) {
        return true
    }

    // this code is same as in gd.ac.project.canCreateTask
    // make sure project user exists
    const projectUser = gd.session.projectUsers.findByProjectAndUser(project.id, gd.user.id)
    if (!projectUser) return false

    // verify with projectAccess settings
    switch (projectUser.access) {
        case ProjectAccess.FULL:
            return true
        case ProjectAccess.STANDARD:
            return gd.company.settings.projectAccess.standard.createTask
        case ProjectAccess.LIMITED:
            return gd.company.settings.projectAccess.limited.createTask
        case ProjectAccess.CLIENT:
        case ProjectAccess.READ_ONLY:
            return false
        default:
            console.error("unknonw option $033kkkk")
            return false
    }



    return true
}